import { defineNuxtPlugin } from "#app";
import { ref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineNuxtPlugin((nuxtApp) => {
  const debug = ref(false);
  const router = useRouter();
  const route = useRoute();

  watchEffect(() => {
    if (process.client) {
      debug.value = route.query.debug === "true";
    }
  });

  function toggleDebug() {
    const newDebugValue = !debug.value;
    router.push({ query: { ...route.query, debug: newDebugValue.toString() } });
  }

  // Set $debug globally on all Vue instances
  nuxtApp.vueApp.config.globalProperties.$debugMode = debug.value;

  // Toggle function
  nuxtApp.vueApp.config.globalProperties.$toggleDebug = toggleDebug;
});
